import parse from 'csv-parse';
import fileType from 'file-type/browser';

import { CSV as CSV_MIME } from 'constants/mimes';

export const getFileContents = file => {
  const reader = new FileReader();

  return new Promise(resolve => {
    reader.onloadend = function (e) {
      if (e.target.readyState !== FileReader.DONE) {
        return;
      }

      resolve(new Uint8Array(e.target.result));
    };

    reader.readAsArrayBuffer(file);
  });
};

// https://stackoverflow.com/a/55136384/696130
export const getFileMime = async file => {
  if (!FileReader) {
    return file.type;
  }

  const bytes = await getFileContents(file.slice(0, fileType.minimumBytes));
  const { mime } = fileType.fromBuffer(bytes);

  return mime;
};

export const getFileHash = async (file, algo = 'SHA-256') => {
  const fileContents = await getFileContents(file);

  const data = await window.crypto.subtle.digest(algo, fileContents);

  // https://stackoverflow.com/a/40031979/696130
  return Array.prototype.map
    .call(new Uint8Array(data), x => ('00' + x.toString(16)).slice(-2))
    .join('');
};

export const readCsvFile = file => {
  return new Promise((resolve, reject) => {
    if (file.type !== CSV_MIME) {
      reject('Only .csv uploads supported');
    }

    const reader = new FileReader();

    reader.onload = () => {
      parse(reader.result, (err, data) => {
        if (err) {
          return reject(err);
        }

        resolve(data);
      });
    };

    reader.readAsBinaryString(file);
  });
};
